import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { HttpHeaders } from "@angular/common/http";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Title } from '@angular/platform-browser';
import { Utilities } from 'src/app/models/utilities';
import { debounceTime, distinctUntilChanged, Observable, OperatorFunction, map, lastValueFrom } from 'rxjs';
import { VendorService } from 'src/app/services/vendor.service';
import * as XLSX from 'xlsx';
import { VendorAWBService } from 'src/app/services/vendorawb.service';

@Component({
  selector: 'edit-add',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})

export class EditVendorAWBComponent implements OnInit, AfterViewInit {
  vendorAWBForm: FormGroup;
  isFormSubmitted = false;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  recordStatusObj = { totalRecord: 0, mappedRecord: 0, unMappedRecord: 0 };
  formatedSCList = [];
  logoContent: any;
  signatureContent: any;
  hubsList = [];

  selectedCompanyLogoFile: File | null = null;
  companyLogoFileName = '';
  companyLogoFileURL = '';
  selectedFile: File | null = null;
  signatureFileName = '';
  signatureFileURL = '';
  locationInfo: any;
  selectedSCId: number;

  showProgressBar = false;
  showsignatrueProgressBar = false;
  progress: number = 0;
  useEnterKey: any;

  vendorList = [];

  rowData = [];
  columnNameList = [
    { name: 'Actual Weight', fieldname: 'weight' },
    { name: 'AWB No', fieldname: 'awbno' },
    { name: 'Amount', fieldname: 'amount' },
    { name: 'Booking Date', fieldname: 'bookingdate' },
    { name: 'Company Code', fieldname: 'companycode' },
    { name: 'Consignee Address1', fieldname: 'consigneeadd1' },
    { name: 'Consignee Address2', fieldname: 'consigneeadd2' },
    { name: 'Consignee Area', fieldname: 'consigneearea' },
    { name: 'Consignee Contact Person', fieldname: 'consigneecontact' },
    { name: 'Consignee Email', fieldname: 'consigneeemail' },
    { name: 'Consignee MobileNo', fieldname: 'consigneemobileno' },
    { name: 'Consignee Name', fieldname: 'consigneename' },
    { name: 'Consignee Pincode', fieldname: 'consigneepin' },
    { name: 'Consignee TelNo', fieldname: 'consigneetelno' },
    { name: 'Customer Code', fieldname: 'customercode' },
    { name: 'Delivery Awb No', fieldname: 'deliveryawbno' },
    { name: 'Delivery Date', fieldname: 'deliverydate' },
    { name: 'Delivery Product', fieldname: 'deliveryproduct' },
    { name: 'Delivery Service', fieldname: 'deliveryservice' },
    { name: 'Delivery Time', fieldname: 'deliverytime' },
    { name: 'Delivery Vendor', fieldname: 'deliveryvendor' },
    { name: 'Destination City Code', fieldname: 'destinationcity' },
    { name: 'Destination Country Code', fieldname: 'destinationcountry' },
    { name: 'Destination State Code', fieldname: 'destinationstate' },
    { name: 'Excepted Delivery Date', fieldname: 'expecteddelvdate' },
    { name: 'Forwarding Awb No', fieldname: 'forwardingawbno' },
    { name: 'Invoice Date', fieldname: 'invoicedate' },
    { name: 'Invoice No', fieldname: 'invoiceno' },
    { name: 'Master Awb No', fieldname: 'masterawbno' },
    { name: 'Origin City Code', fieldname: 'origincity' },
    { name: 'Origin Country Code', fieldname: 'origincountry' },
    { name: 'Origin State Code', fieldname: 'originstate' },
    { name: 'Product Code', fieldname: 'product' },
    { name: 'Receiver Name', fieldname: 'receiver' },
    { name: 'Receiver TelNo', fieldname: 'recicevertel' },
    { name: 'Reference No', fieldname: 'refno' },
    { name: 'Remark', fieldname: 'remark' },
    { name: 'Service Name', fieldname: 'servicename' },
    { name: 'Shipment Contact Person', fieldname: 'shippercontact' },
    { name: 'Shipment Value', fieldname: 'shipmentvalue' },
    { name: 'Shipper Address1', fieldname: 'shipperadd1' },
    { name: 'Shipper Address2', fieldname: 'shipperadd2' },
    { name: 'Shipper Area', fieldname: 'shipperarea' },
    { name: 'Shipper DocumentNo', fieldname: 'shipperdocumentno' },
    { name: 'Shipper DocumentType', fieldname: 'shipperdocumenttype' },
    { name: 'Shipper Email', fieldname: 'shipperemail' },
    { name: 'Shipper MobileNo', fieldname: 'shippermobileno' },
    { name: 'Shipper Name', fieldname: 'shippername' },
    { name: 'Shipper Pincode', fieldname: 'shipperpin' },
    { name: 'Shipper TelNo', fieldname: 'shippertelno' },
    { name: 'Transaction Status', fieldname: 'transactionstatus' },
    { name: 'Total Pieces', fieldname: 'pcs' },
    { name: 'Vendor Code', fieldname: 'vendorcode' },
    { name: 'Vendor Weight', fieldname: 'vendorweight' },
    { name: 'Volumetric Weight', fieldname: 'volumetricweight' },
    { name: 'Weight Unit', fieldname: 'unit' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appCoreService: AppCoreService,
    private fileHandlerService: FileHandlerService,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private utilities: Utilities,
    private vendorService: VendorService,
    private vendorAWBService: VendorAWBService,
    private ngxUiLoaderService: NgxUiLoaderService,
  ) {
    titleService.setTitle('Vendor AWB');

  }
  mappingId: any;
  async ngOnInit() {
    this.mappingId = this.route.snapshot.params['id'];
    this.vendorAWBForm = this.formBuilder.group({
      txtVendor: [null, Validators.required],
      txtFile: [null],
      txtFieldSelect: this.formBuilder.array([])
    });
    this.checkPermission();
    if (this.permConfig.isEditAllowed) {
      await this.getAllVendors();
      this.getMappingById()
      this.appCoreService.SelectedServiceCenter().subscribe(async (val) => {
        this.selectedSCId = val;
      })
    }
  }

  get txtFieldSelect(): FormArray {
    return this.vendorAWBForm.get('txtFieldSelect') as FormArray;
  }

  // Save the selected row's data
  update(): void {
    if (this.vendorAWBForm.valid && this.rowData.length) {
      const reqObj = {
        id: this.mappingId,
        vendorid: this.vendorAWBForm.get('txtVendor')?.value?.id,
        awbmapping: this.rowData,
        generatedfromid: this.selectedSCId
      }
      // save the list to database
      // console.log('reqObj', reqObj);
      this.ngxUiLoaderService.start();
      this.vendorAWBService.Update(reqObj).subscribe(res => {
        if (res?.success) {
          this.ngxUiLoaderService.stop();
          this.openSuccessDialog('Record Saved Successfully');
        }
      })

    } else {
      console.log('No row selected');
    }
  }

  getMappingById() {
    this.vendorAWBService.GetById(this.mappingId).subscribe(res => {
      if (res?.success) {
        this.vendorAWBForm.get('txtVendor').setValue(this.vendorList.find(v => v.id == res.data[0].vendorid));
        this.rowData = res.data[0].awbmapping;
        //update count 
        this.getRecordStatus(this.rowData);
      }
    });
  }


  updateMappingField(selectedFieldname: string, displayname: string) {
    const itemIndex = this.rowData.findIndex(item => item.displayname === displayname);
    if (itemIndex > -1) {
      this.rowData[itemIndex].fieldname = selectedFieldname;
      //update count 
      this.getRecordStatus(this.rowData);
    }
  }

  getRecordStatus(inputList: any[]) {
    this.recordStatusObj = { totalRecord: 0, mappedRecord: 0, unMappedRecord: 0 };
    this.recordStatusObj = inputList.reduce((status, record) => {
      status.totalRecord++;
      record.fieldname ? status.mappedRecord++ : status.unMappedRecord++;
      return status;
    }, this.recordStatusObj);
  }

  async getAllVendors() {
    const res = await lastValueFrom(this.vendorService.GetAll({ isactive: true }));
    if (res?.success) {
      this.vendorList = res.data;
    };
  }
  search: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.vendorList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  formatter = (x: { name: string }) => x.name;

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.vendorAWBForm) : null;
  }
  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Vendor AWB');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  validateFileType(file: File) {
    const allowedTypes = ['image/jpg', 'image/jpeg', 'image/png'];
    if (allowedTypes.includes(file.type)) {
    } else {
      this.openCorrectFileType();
    }
  }

  excelsheetHeaders: string[] = []; // Store headers

  onChangeFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      console.error('No file selected');
      return;
    }
    this.rowData = [];
    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: 'array' });

      // Process the first sheet only
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      if (jsonData.length > 0) {
        const excelsheetHeaders = jsonData[0] as string[];
        // console.log('Excel Sheet Headers:', excelsheetHeaders);

        this.txtFieldSelect.clear();

        // Populate FormArray with controls and rowData
        excelsheetHeaders.forEach((item, index) => {
          //form control to show required fields
          this.txtFieldSelect.push(this.formBuilder.control(item));
          this.rowData.push({ displayname: item, fieldname: '' });
        });
      }
      // console.log('Row Data:', this.rowData); // Logs the rowData array with headers
      // console.log('txtFieldSelect:', this.txtFieldSelect); // Logs the rowData array with headers
    };

    reader.readAsArrayBuffer(file);
  }

  uploadFile() {
    try {
      let interval: any;
      let timeout: any;
      // console.log(" selectedFile",this.selectedFile);
      if (this.selectedFile) {
        let requestObj = {
          name: this.selectedFile.name,
          fileType: this.selectedFile.type,
          category: 'receiptentry-import'
        };
        this.showProgressBar = true;
        interval = setInterval(() => {
          if (this.progress < 99) {
            this.progress += 1;
          } else {
            timeout = setTimeout(() => {
              this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
            }, 20000);
          }
        }, 100);
        this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
          try {
            if (res && res.success) {
              // console.log("GetSignedURLForUpload",res.data)
              const signedUrl = res.data.uploadURL;
              const fileid = res.data.fileId;
              if (signedUrl) {
                let headers: HttpHeaders = new HttpHeaders({
                  "Content-Type": requestObj.fileType
                });

                this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                  if (f === null) {
                    this.fileHandlerService.UploadComplete({ id: fileid }).subscribe((res) => {
                      // console.log("UploadComplete",res?.data)
                      if (res && res.success) {
                        this.progress = 100;
                        this.processReceiptImport(fileid);
                        clearInterval(interval);
                        clearTimeout(timeout);
                      }
                    });
                  }
                });
              }
            }
          }
          catch (error) {
            clearInterval(interval);
            clearTimeout(timeout);
            this.showProgressBar = false;
            console.error(error);
          }
        });
      } else {
        this.appCoreService.showMessage('Select an excel file to upload', '', 'error');
      }
    } catch (error) {
      console.error(error);
    }
  }

  processReceiptImport(fileid) {
    try {
      const requestObj = {
        fileid
      }
      // this.receiptService.receiptImport(requestObj).subscribe((res) => {
      //     if (res && res.success) {
      //         this.showProgressBar = false;
      //         this.activeModal.close('Import Successfully');
      //     }
      //     if (res && !res.success) {
      //         this.showProgressBar = false;
      //         this.activeModal.dismiss();
      //         this.warningDialog(res.message, res.data);
      //     }
      // })
    } catch (error) {
      console.error(error);
    }
  }

  openCorrectFileType() {
    this.openErrorDialog('Only JPEG, PNG, and JPG file formats are accepted');
  }

  async openSuccessDialog(msg: any) {
    const result = await Swal.fire({
      // title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.router.navigate(['/config/vendorawb'])
    }
  }

  async openErrorDialog(msg: any) {
    await Swal.fire({
      // title: 'Error!',
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK'
    })
  }

  warningDialog(msg: any) {
    Swal.fire({
      // title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  resetForm(): void {
    this.vendorAWBForm.reset();
    this.isFormSubmitted = false;
  }
}